import { Collapse as _Collapse, CollapseProps as CollapsePropsV5 } from 'antd5';
import { CollapseV5 } from './Collapse.style';

type CollapseProps = CollapsePropsV5;

const Collapse: React.FunctionComponent<CollapseProps> = props => {
  return <CollapseV5 {...props} />;
};

const CollapseNamespace = Object.assign(Collapse, { Panel: _Collapse.Panel });

export { CollapseNamespace as Collapse };
